<template>
  <div>
    <b-form-group
      :label="$t('reusable.common.name') + ':'"
      label-for="input-name"
      label-cols="3"
      label-cols-sm="2"
      class="label"
    >
      <b-form-input
        id="input-name"
        name="input-name"
        v-model="$v.profile_competence_mention.name.$model"
        :state="validateState('name')"
        aria-describedby="input-name-live-feedback"
        size="sm"
        class="input-name"
      ></b-form-input>
      <b-form-invalid-feedback id="input-name-live-feedback">{{
        $t("reusable.common.minLength", { min: 3 })
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$t('curricularMesh.curricularMeshView.type') + ':'"
      label-for="input-type"
      label-cols="3"
      label-cols-sm="2"
      class="label"
    >
      <div class="d-flex align-items-center">
        <b-form-select
          id="input-type"
          v-model="$v.profile_competence_mention.type.$model"
          :state="validateState('type')"
          aria-describedby="input-type-feedback"
          size="sm"
          :style="
            profile_competence_mention.type === 5
              ? 'flex: 0 0 auto; width: auto; min-width: 150px;'
              : 'width: 100%;'
          "
        >
          <b-form-select-option :value="null">{{
            $t("curricularMesh.curricularMeshView.selectType")
          }}</b-form-select-option>
          <b-form-select-option :value="1">{{
            $t("curricularMesh.curricularMeshView.mention")
          }}</b-form-select-option>
          <b-form-select-option :value="2">{{
            $t("curricularMesh.curricularMeshView.diploma")
          }}</b-form-select-option>
          <b-form-select-option :value="3">{{
            $t("curricularMesh.curricularMeshView.specialization")
          }}</b-form-select-option>
          <b-form-select-option :value="4">{{
            $t("curricularMesh.curricularMeshView.certification")
          }}</b-form-select-option>
          <b-form-select-option :value="5">{{
            $t("curricularMesh.curricularMeshView.other")
          }}</b-form-select-option>
        </b-form-select>
        <template v-if="profile_competence_mention.type === 5">
          <span class="mx-2">:</span>
          <b-form-input
            id="input-other-type-name"
            v-model="$v.profile_competence_mention.other_type_name.$model"
            :state="validateState('other_type_name')"
            aria-describedby="input-other-type-name-feedback"
            size="sm"
            :placeholder="$t('curricularMesh.curricularMeshView.specifyType')"
            style="flex: 1"
          ></b-form-input>
        </template>
      </div>
      <div
        v-if="validateState('type') === false"
        class="invalid-feedback"
        style="display: block"
        id="input-type-feedback"
      >
        {{ $t("reusable.common.required") }}
      </div>
      <div
        v-if="
          profile_competence_mention.type === 5 &&
          validateState('other_type_name') === false
        "
        class="invalid-feedback"
        style="display: block"
        id="input-other-type-name-feedback"
      >
        {{ $t("curricularMesh.curricularMeshView.requiredWhenOther") }}
      </div>
    </b-form-group>
    <b-form-group
      :label="$t('reusable.common.description') + ':'"
      label-for="input-description"
      label-cols="3"
      label-cols-sm="2"
      class="label"
    >
      <div
        class="profile_competence_mention-form-description mr-0 mt-1"
        @click="
          $bvModal.show(
            `edit-profile_competence_mention-description-modal-${profile_competence_mention.id}`
          )
        "
      >
        <RenderVHtml
          v-b-tooltip.v-secondary.noninteractive.hover="{
            title: $t('reusable.common.editDescription'),
            boundary: 'viewport',
          }"
          :content="profile_competence_mention.description"
        ></RenderVHtml>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-profile_competence_mention-description-modal-${profile_competence_mention.id}`"
        :title_modal="$t('reusable.common.editDescription')"
        :size_modal="`lg`"
        :object_rich_text="profile_competence_mention"
        :content_rich_text="profile_competence_mention.description"
        :show_last_modification="true"
        @save="
          (content) =>
            patchProfileCompetenceMention(profile_competence_mention, content)
        "
        @close="
          $bvModal.hide(
            `edit-profile_competence_mention-description-modal-${profile_competence_mention.id}`
          )
        "
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-profile_competence_mention-description-modal-${profile_competence_mention.id}`"
        title="Editar Descripción"
        size="lg"
        hide-footer
      >
        <NewRichTextEditor
          :Object="profile_competence_mention"
          :Text="profile_competence_mention.description"
          @save="patchProfileCompetenceMention"
          @close="
            $bvModal.hide(
              `edit-profile_competence_mention-description-modal-${profile_competence_mention.id}`
            )
          "
        ></NewRichTextEditor>
      </b-modal> -->
      <b-form-invalid-feedback id="input-description-feedback">{{
        $t("curricularMesh.curricularMeshView.optionalField")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="$getVisibleNames('mesh.competence', true, 'Competencias') + ':'"
      label-for="input-egress_profile_competences"
      label-cols="3"
      label-cols-sm="2"
      class="label"
    >
      <b-form-select
        v-if="competenceOptions.length > 0"
        id="input-egress_profile_competences"
        v-model="
          $v.profile_competence_mention.egress_profile_competences.$model
        "
        :state="validateState('egress_profile_competences')"
        aria-describedby="input-egress_profile_competences-feedback"
        size="sm"
        multiple
        :select-size="
          competenceOptions.length <= 5 ? competenceOptions.length : 9
        "
        class="select-form"
      >
        <b-select-option
          class="select-option"
          v-for="item in competenceOptions"
          :value="item.id"
          :key="item.id"
          :title="item.name"
        >
          {{ item.name }}
        </b-select-option>
      </b-form-select>
      <div class="pt-2" v-else>
        {{
          $t("curricularMesh.curricularMeshView.profileWithoutCompetences", {
            profile: $getVisibleNames(
              "mesh.egressprofile",
              false,
              "Perfil de Egreso"
            ).toLowerCase(),
            competences: $getVisibleNames(
              "mesh.competence",
              true,
              "Competencias"
            ).toLowerCase(),
          })
        }}
      </div>
      <b-form-invalid-feedback id="input-egress_profile_competences-feedback">{{
        $t("reusable.common.required")
      }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="!isNaN(profile_competence_mention.id)"
      label-for="input-modification-date"
      label-cols="0"
      label-cols-sm="0"
      class="p-0 m-0 mt-2"
    >
      <ModificationDate
        :Information="profile_competence_mention"
      ></ModificationDate>
    </b-form-group>
    <div class="row mt-3">
      <div
        v-if="show_delete_button && !isNaN(this.profile_competence_mention.id)"
        class="col"
        style="text-align: left"
      >
        <b-button
          class="mr-1"
          size="sm"
          variant="danger"
          @click="askForDeleteObject"
          >{{ $t("reusable.common.delete") }}</b-button
        >
      </div>
      <div v-if="show_save_button" class="col" style="text-align: right">
        <b-button class="m-0 mr-1" size="sm" @click="save">{{
          $t("reusable.common.save")
        }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { generateUniqueId, toast } from "@/utils/utils";
import { validationMixin } from "vuelidate";
import { required, minLength, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "EgressProfileCompetenceMetionForm",
  mixins: [validationMixin],
  components: {
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    egress_profile_id: {
      type: Number,
      required: true,
    },
    ProfileCompetenceMention: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          name: "",
          description: "",
          type: null,
          other_type_name: "",
          egress_profile: this.egress_profile_id,
          egress_profile_competences: [],
          creation_date: null,
          created_by: null,
          update_date: null,
          updated_by: null,
        };
      },
    },
    show_save_button: {
      type: Boolean,
      default: true,
    },
    show_delete_button: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      profile_competence_mention: { ...this.ProfileCompetenceMention },
    };
  },
  validations: {
    profile_competence_mention: {
      name: {
        required,
        minLength: minLength(3),
      },
      description: {},
      type: {
        required,
      },
      other_type_name: {
        required: requiredIf(function () {
          return this.profile_competence_mention.type === 5;
        }),
      },
      egress_profile: {
        required,
      },
      egress_profile_competences: {},
    },
  },
  computed: {
    ...mapGetters({
      competences: names.COMPETENCES,
      profile_competences: names.PROFILE_COMPETENCES,
      egressProfileCycles: names.PROFILE_CYCLES,
    }),
    competenceOptions() {
      let list = [];
      list = this.profile_competences
        .filter((x) => x.egress_profile == this.egress_profile_id)
        .map((objeto) => {
          return {
            ...objeto,
            name:
              objeto.order +
                "." +
                ((
                  this.egressProfileCycles.find(
                    (x) =>
                      x.egress_profile == this.egress_profile_id &&
                      x.cycle == objeto.cycle
                  ) || {}
                ).order || "-") +
                " " +
                (this.competences.find((x) => x.id == objeto.competence) || {})
                  .full_sentence || "",
            profile_cycle_order:
              (
                this.egressProfileCycles.find(
                  (x) =>
                    x.egress_profile == this.egress_profile_id &&
                    x.cycle == objeto.cycle
                ) || {}
              ).order || 1000,
          };
        });
      return list.sort(function (a, b) {
        if (a.order > b.order) return 1;
        if (a.order < b.order) return -1;
        if (a.profile_cycle_order > b.profile_cycle_order) return 1;
        if (a.profile_cycle_order < b.profile_cycle_order) return -1;
        return 0;
      });
    },
  },
  watch: {
    "profile_competence_mention.type"(newValue) {
      if (newValue !== 5) {
        this.profile_competence_mention.other_type_name = "";
      }
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.profile_competence_mention[name];
      return $dirty ? !$error : null;
    },
    patchProfileCompetenceMention(object, text) {
      this.profile_competence_mention.description = text;
    },
    save() {
      this.$v.profile_competence_mention.$touch();
      if (this.$v.profile_competence_mention.$anyError) {
        return;
      }
      if (isNaN(this.profile_competence_mention.id))
        this.createProfileCompetenceMention();
      else this.updateProfileCompetenceMention();
    },
    createProfileCompetenceMention() {
      this.$store
        .dispatch(
          names.POST_PROFILE_COMPETENCE_MENTION,
          this.profile_competence_mention
        )
        .then((response) => {
          toast(
            String(
              this.$getVisibleNames(
                "mesh.egressprofilecompetencemention",
                false,
                "Mención"
              ) +
                " " +
                this.$t("reusable.common.created")
            )
          );
          this.$emit("created", response);
        });
    },
    updateProfileCompetenceMention() {
      this.$store
        .dispatch(
          names.UPDATE_PROFILE_COMPETENCE_MENTION,
          this.profile_competence_mention
        )
        .then((response) => {
          toast(
            String(
              this.$getVisibleNames(
                "mesh.egressprofilecompetencemention",
                false,
                "Mención"
              ) +
                " " +
                this.$t("reusable.common.updated")
            )
          );
          this.$emit("updated", response);
        });
    },
    askForDeleteObject() {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.egressprofilecompetencemention",
            false,
            "Mención"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(
            names.DELETE_PROFILE_COMPETENCE_MENTION,
            this.profile_competence_mention.id
          );
          toast(
            String(
              this.$getVisibleNames(
                "mesh.egressprofilecompetencemention",
                false,
                "Mención"
              ) +
                " " +
                this.$t("reusable.common.deleted")
            )
          );
          this.$emit("deleted", this.profile_competence_mention);
        }
      });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
.select-form {
  display: block !important;
}
.profile_competence_mention-form-description {
  width: calc(100%);
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.875rem;
  min-height: calc(1.5em + 0.5rem + 2px);
  height: auto;
  padding: 0.25rem 1.2rem;
  line-height: 1.5;
}
.select-option {
  overflow: auto;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  padding: 0 0.25em;
  margin-bottom: 0.25rem;
}
</style>